<template>
  <div class="vx-row mb-12">
    <div
      v-bind:class="[
        detail ? detailShow + 'md:w-1/3 w-full mb-base' : '',
        detailHide,
      ]"
    >
      <vs-table
        search
        stripe
        border
        description
        :sst="true"
        :data="table.data"
        :max-items="table.length"
        :total="table.total"
        @search="handleSearch"
        @change-page="handleChangePage"
        @sort="handleSort"
        multiple
        v-model="selected"
        not-click-selected
        open-expand-only-td
      >
        <template slot="header">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="
                p-3
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
              <span class="mr-2"
                >{{ this.table.start }} - {{ this.table.end }} of
                {{ this.table.total }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item
                v-for="item in table.limits"
                :key="item"
                @click="handleChangelength(item)"
              >
                <span>{{ item }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </template>
        <template slot="thead">
          <vs-th width="15%">Select All</vs-th>
          <vs-th>Supplier Data</vs-th>
          <vs-th>Invoice Data</vs-th>
          <vs-th>Invoice Date</vs-th>
          <vs-th>Invoice Group</vs-th>
          <vs-th>Invoice Type</vs-th>
          <vs-th>Tax Data</vs-th>
          <vs-th>PO Data</vs-th>
          <vs-th>GR Data</vs-th>
          <vs-th>Un-match Value</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
            :class="data[indextr].class"
          >
            <vs-td class="whitespace-no-wrap">
              <template>
                <vx-tooltip text="Edit / Show Invoice">
                  <vs-button
                    type="line"
                    icon-pack="feather"
                    @click.stop="
                      handleEdit(
                        data[indextr].id,
                        indextr,
                        data[indextr].po_code,
                        data[indextr].supplier_code,
                        data[indextr].supplier_name,
                        data[indextr].inv_code,
                        data[indextr].warehouse_code,
                        data[indextr].warehouse_name,
                        data[indextr].created_date,
                        data[indextr].status,
                        data[indextr].due_date,
                      )
                    "
                    icon="icon-eye"
                  />
                </vx-tooltip>
                <vx-tooltip text="Reject Invoice">
                  <vs-button
                    color="danger"
                    type="line"
                    icon-pack="feather"
                    @click="reject(tr.id, tr.inv_code)"
                    icon="icon-x-circle"
                  />
                </vx-tooltip>
                <vx-tooltip text="Reopen Invoice">
                  <vs-button
                    color="danger"
                    type="line"
                    icon-pack="feather"
                    @click="reopen(tr.id, tr.inv_code)"
                    icon="icon-repeat"
                  />
                </vx-tooltip>
              </template>
            </vs-td>
            <vs-td :data="data[indextr].supplier_name">
              <div class="vx-row ml-0">
                <span class="w-5/5"
                  >{{ data[indextr].supplier_code }} -
                  {{ data[indextr].supplier_name }}</span
                >
              </div>
              <div class="vx-row ml-0">
                <span class="w-5/5"
                  >{{ data[indextr].supplier_address }},
                  {{ data[indextr].supplier_city }} ({{
                    data[indextr].supplier_contact_name
                  }}
                  - {{ data[indextr].supplier_phone }})</span
                >
              </div>
            </vs-td>
            <vs-td>
              Total Value : 
              {{ 
                parseFloat(data[indextr].total_invoice_value)
                  .toFixed(2)
                  .toString()
                  .replace(/,/g, "")
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",") 
              }}<br>
              External Number :
              {{ data[indextr].inv_code ? data[indextr].inv_code : "-" }}<br />
              {{ data[indextr].code_internal != "" ? "Internal Number : " + data[indextr].code_internal : "" }}
            </vs-td>
            <vs-td> {{ data[indextr].inv_code ? dateFormat(data[indextr].inv_date) : "-" }} </vs-td>
            <vs-td> {{ data[indextr].po_type }} </vs-td>
            <vs-td> {{ data[indextr].po_type }} </vs-td>
            <vs-td> {{ data[indextr].tax }} </vs-td>
            <vs-td v-if="tr.po_code_external != ''" :data="data[indextr].po_code">
              Internal Number : {{ data[indextr].po_code }}<br>
              External Number : {{ data[indextr].po_code_external }}<br>
              Date : {{ data[indextr].po_date }}
            </vs-td>
            <vs-td v-else :data="data[indextr].po_code">
              Number : {{ data[indextr].po_code }}<br>
              Date : {{ data[indextr].po_date }}
            </vs-td>
            <vs-td> {{ data[indextr].gr_code }} </vs-td>
            <vs-td> {{ 
                parseFloat(data[indextr].total_invoice_value)
                  .toFixed(2)
                  .toString()
                  .replace(/,/g, "")
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",") 
              }} 
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        style="padding-top: 5px"
        :total="table.totalPage"
        v-model="setPage"
      />
    </div>
    <div class="vx-row mb-2 mt-2" v-if=" selected &&  selected.length > 0">
      <div class="vx-col w-full">
        <vs-button class="m-2 " @click.stop="handleForceValid">Force Valid
        </vs-button>
      </div>
    </div>
    <!-- form -->
    <transition name="detail-fade">
      <div
        v-if="detail"
        v-bind:class="[
          detail ? detailShow + 'md:w-2/3 w-full mb-base' : '',
          detailHide,
        ]"
      >
        <vs-row>
          <vs-col
            style="padding-bottom: 8px"
            vs-offset="8"
            vs-type="flex"
            vs-justify="rigth"
            vs-align="rigth"
            vs-w="4"
          >
            <vs-button
              class="ml-auto"
              size="small"
              v-on:click="handleClose"
              color="grey"
              icon-pack="feather"
              icon="icon-x-square"
              >Close</vs-button
            >
          </vs-col>
          <vs-col
            class="vertical-divider"
            vs-offset="0"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="1"
          >
            <vs-button
              size="small"
              v-on:click="handleClose"
              color="grey"
              icon-pack="feather"
              icon="icon-x-square"
            ></vs-button>
          </vs-col>
          <detail
            @close="handleClose"
            :piId="piId"
            :vendor="vendor"
            :poCode="poCode"
            :invCode="invCode"
            :warehouseCode="warehouseCode"
            :warehouseName="warehouseName"
            :createdDate="createdDate"
            :status="status"
            :dueDate="dueDate"
          >
          </detail>
        </vs-row>
      </div>
    </transition>
    <div>
      <vs-prompt
        color="danger"
        title="Confirmation"
        @cancel="val = ''"
        @accept="doReopen"
        @close="closeReopen"
        :active.sync="activePromptReopen"
      >
        <div class="con-exemple-prompt">
          Are you sure reopen invoice {{ invCode }} ? <br> Please fill in the note first.
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input
                v-validate="'required'"
                class="w-full"
                name="Note"
                v-model="note"
                placeholder="Note"
              />
            </div>
          </div>
        </div>
      </vs-prompt>
    </div>
    <div>
      <vs-prompt
        color="danger"
        title="Confirmation"
        @cancel="val = ''"
        @accept="doReject"
        @close="closeReject"
        :active.sync="activePromptReject"
      >
        <div class="con-exemple-prompt">
          Are you sure rejected invoice {{ invCode }} ?
        </div>
      </vs-prompt>
    </div>
    <div>
      <vs-prompt
        color="danger"
        title="Confirmation"
        @cancel="val = ''"
        @accept="doForceValid"
        @close="closeForceValid"
        :active.sync="activePromptForceValid"
      >
        <div class="con-exemple-prompt">
          Are you sure force valid invoice {{ invCode }} ?<br> Please fill in the transaction date first.
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label class="vs-input--label">Transaction Date</label>
              <datepicker
                class="w-full"
                v-validate="'required'"
                :inline="false"
                name="Transaction Date"
                v-model="transaction_date"
                placeholder="Transaction date"
                format="MMMM dd, yyyy"
                label="Transaction Date"
                :disabledDates="disabledAfterToday"
              ></datepicker>
              <span
                class="text-danger text-sm"
                v-if="transaction_date == null && status_submit"
                >This field is required</span
              >
            </div>
          </div>
        </div>
      </vs-prompt>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import Detail from "./detail.vue";
import moment from "moment";
export default {
  components: {
    Datepicker,
    Detail,
  },
  data() {
    return {
      selected: [],
      detailShow: "core vx-col ",
      detailHide: "core vx-col md:w-1/1 w-full mb-base ",
      detail: false,
      statusView: false,
      status_submit: false,
      status: '',
      deleteId: null,
      piId: null,
      invCode: "",
      vendor: null,
      poCode: null,
      warehouseCode: null,
      warehouseName: null,
      index1: 0,
      data: [],
      table: {
        data: [],
        length: 5,
        page: 1,
        search: "",
        order: "date",
        sort: "asc",
        total: 0,
        totalPage: 0,
        totalSearch: 0,
        limits: [5, 10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      },
      activePrompt: false,
      activePromptReject: false,
      activePromptReopen: false,
      activePromptForceValid: false,
      createdDate: null,
      dueDate: null,
      transaction_date: new Date(),
      disabledAfterToday: {
        from: new Date(), // Disable all dates after specific date
      },
      note: "",
      selectedItems: [],
      selectAll: false,
      isAllSelected: false,
      checked: [],
      selectable: true,
    };
  },
  methods: {
    dateFormat(date) {
      if (date) {
        return moment(String(date)).format("YYYY-MM-DD");
      }
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      this.getData();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getData();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },
    handleClose() {
      this.getData();
      this.detail = false;
    },
    handleForceValid(){
      console.log("selected",this.selected)
      if(this.selected && this.selected.length > 0) {
        this.activePromptForceValid = true 
      }
    },
    closeForceValid() {
      this.activePromptForceValid = false
      this.invCode = ''
    },
    doForceValid() {
      this.status_submit = true;
      const ids = this.selected.map(select => select.id);
      console.log("IDS",ids)
      console.log("transaction date",moment(this.transaction_date))
      this.$vs.loading();
      let param = {
        id: ids,
        status: "15",
        transaction_date: moment(this.transaction_date),
      };
      this.$http
        .post("/api/v1/pi/change-status-ocr", param)
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.handleClose();
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    reject(id, invCode){
      this.invCode = invCode
      this.piId = id
      this.activePromptReject = true
    },
    closeReject() {
      this.activePromptReject = false
      this.invCode = ''
    },
    doReject() {
      this.$vs.loading();
      let param = {
        id: this.piId,
        status: '28'
      };
      this.$http
        .post("/api/v1/pi/change-status", param)
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.handleClose();
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    reopen(id, invCode){
      this.invCode = invCode
      this.piId = id
      this.activePromptReopen = true
    },
    closeReopen() {
      this.activePromptReopen = false
      this.invCode = ''
    },
    doReopen() {
      this.$vs.loading();
      let param = {
        id: this.piId,
        status: '22',
        note: this.note
      };
      this.$http
        .post("/api/v1/pi/change-status", param)
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.handleClose();
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get("/api/v1/pi/vendor-invoice", {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            order: this.table.order,
            sort: this.table.sort,
            territory_id: this.$userLogin.territory_id,
            territory_area_id: this.$userLogin.territory_area_id,
            status: "2",
            po_type: "non-trade"
          },
        })
        .then((resp) => {
          if (resp.status == "success") {
            this.table.total = resp.data.record_total;
            this.table.totalPage = resp.data.page_total;
            this.table.totalSearch = resp.data.record_total_search;
            this.table.length = resp.data.record_total_per_page;
            this.table.data = resp.data.records;
            this.data = resp.data.records;
            this.setStartEnd();
            this.$vs.loading.close();
            console.log(resp.data.records)
          }
        });
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;
      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;
      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }
      if (this.table.totalSearch < this.table.total) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    handleCreate() {
      this.detail = true;
    },
    handleEdit(id, index, poCode, vendorCode, vendorName, invCode, warehouseCode, warehouseName, createdDate, status, dueDate) {
      this.piId = id;
      this.vendor = vendorCode + " - " + vendorName;
      this.poCode = poCode;
      this.createdDate = moment(String(createdDate)).format("DD/MM/YYYY");
      this.invCode = invCode ? invCode : "0";
      this.table.data = [];
      this.table.data = this.data;
      this.warehouseCode = warehouseCode;
      this.warehouseName = warehouseName;
      this.status = status;
      this.dueDate = moment(String(dueDate)).format("YYYY-MM-DD") == "0001-01-01" ? "" : moment(String(new Date(dueDate))).format("DD/MM/YYYY");

      this.table.data[this.index1].class = "";
      this.table.data[index].class = "highlight";
      this.detail = true;
      this.index1 = index;
    },
  },
  mounted() {},
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
  watch: {},
};
</script>

<style scoped>
.core-enter-active {
  transition: all 0.3s ease;
}

.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.core-enter,
    .core-leave-to

    /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.core {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}

.vertical-divider {
  border-left: 1px solid #7367f0;
  min-height: 800px;
  padding: 5px;
}

.highlight > td {
  background-color: #d0cdf0;
}
</style>